import types from '../actions/certificationActionsTypes';

const INITIAL_STATE = {
    isCertificatesLoading: false,
    selectedCertification: {},
    selectedUser: {},
    modeCertificationModal: null,
    showCertificationModal: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_CERTIFICATES_LOADING:
            return { ...state, isCertificatesLoading: action.payload };
        case types.SET_SELECTED_CERTIFICATION:
            return { ...state, selectedCertification: action.payload };
        case types.SET_SELECTED_USER:
            return { ...state, selectedUser: action.payload };
        case types.SET_MODE_CERTIFICATION_MODAL:
            return { ...state, modeCertificationModal: action.payload };
        case types.SET_SHOW_CERTIFICATION_MODAL:
            return { ...state, showCertificationModal: action.payload };
        case types.RESET_STATE:
            return INITIAL_STATE;

        default:
            return state;
    }
};
